<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>
    <div class="modal-header">
    <h5 class="modal-title">{{ title | slice:0:1 | uppercase }}{{ title | slice:1 }} <span
            *ngIf="itemToSave.type_service_codification">{{itemToSave.type_service_codification}}</span></h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Fermer"></button>
  </div>
  <div class="modal-body">
    <div class="row">

    <div class="row" style="width:100%">
      <!-- Début date -->

      <!-- Heure début -->
      <div class="col-md-2 mb-3">
        <label class="form-label">Date début</label>
        <input disabled type="text" class="form-control" [(ngModel)]="itemToSave.date_debut_formatted" name="date_debut_formatted"
          #date_debut_formattedCtrl="ngModel" />
        <div class="text-danger" *ngIf="date_debut_formattedCtrl.invalid && date_debut_formattedCtrl.touched">
          Date début est requise
        </div>
      </div>
      <div class="col-md-2 mb-3">
        <label class="form-label">Date fin</label>
        <input disabled type="text" class="form-control" [(ngModel)]="itemToSave.date_fin_formatted" name="date_fin_formatted"
          #date_fin_formattedCtrl="ngModel" />
        <div class="text-danger" *ngIf="date_fin_formattedCtrl.invalid && date_fin_formattedCtrl.touched">
          Date fin est requise
        </div>
      </div>

      <!-- Fin date -->
      <div class="col-md-2 mb-3" *ngIf="current_service.id && current_service.codification !='PASS'">
        <label class="form-label">Date fin</label>
        <input autocomplete="off" class="form-control" [(ngModel)]="itemToSave.date_fin" name="date_fin"
          #date_finCtrl="ngModel" required bsDatepicker [(bsValue)]="myDate" [bsConfig]="datePickerConfig" />
        <div class="text-danger" *ngIf="date_finCtrl.invalid && date_finCtrl.touched">
          Date fin est requise
        </div>
      </div>


      <!-- Heure fin -->




      <!-- Chambre -->
      <div class="col-md-3 mb-3" style="position: relative;">
        <label class="form-label">Chambre</label>
        <input disabled type="text" class="form-control" [(ngModel)]="itemToSave.chambre_libelle" name="chambre_libelle"
          #montant_totalCtrl="ngModel" required />
      </div>

      <!-- Client -->
      <div class="col-md-3 mb-3">
        <label class="form-label">Client</label>
        <select disabled class="form-select" name="client_id" [(ngModel)]="itemToSave.client_id" required
          #client_idCtrl="ngModel">
          <option *ngFor="let item of itemsClient" [value]="item.id">
            {{ item.nom }}/{{ item.telephone }}
          </option>
        </select>
        <div class="text-danger" *ngIf="client_idCtrl.invalid && client_idCtrl.touched">
          Client est requis
        </div>
      </div>
      <!-- Montant total -->
      <div class="col-md-2 mb-3">
        <label class="form-label">Montant total</label>
        <input disabled type="number" class="form-control" [(ngModel)]="itemToSave.montant_total" name="montant_total"
          #montant_totalCtrl="ngModel" required />
        <div class="text-danger" *ngIf="montant_totalCtrl.invalid && montant_totalCtrl.touched">
          Montant total est requis
        </div>
      </div>

      <!-- Avance -->
      <div class="col-md-2 mb-3">
        <label class="form-label">Avance</label>
        <input disabled type="number" class="form-control" [(ngModel)]="itemToSave.montant_avance" name="montant_avance"
          #montant_avanceCtrl="ngModel" (input)="onCalculateMonnaie()" required />
        <div class="text-danger" *ngIf="montant_avanceCtrl.invalid && montant_avanceCtrl.touched">
          Montant avance est requis
        </div>
      </div>

      <!-- Apporteur -->
      <div class="col-md-2 mb-3" *ngIf="this.itemToSave.apporteur_id">
        <label class="form-label">Apporteur</label>
        <select disabled class="form-select" name="apporteur_id" [(ngModel)]="itemToSave.apporteur_id" required
          #apporteur_idCtrl="ngModel">
          <option *ngFor="let item of itemsApporteur" [value]="item.id">
            {{ item.nom }}/{{ item.telephone }}
          </option>
        </select>
        <div class="text-danger" *ngIf="apporteur_idCtrl.invalid && apporteur_idCtrl.touched">
          Apporteur est requis
        </div>
      </div>


      <!-- Mode règlement -->
      <div class="col-md-2 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Mode règlement</label>
        <select class="form-select" [(ngModel)]="itemToSave.mode_reglement_id" name="mode_reglement_id"
          #mode_reglement_idCtrl="ngModel" required>
          <option *ngFor="let item of itemsModeReglement" [value]="item.id"
            [disabled]="item.codification === 'FIDELITY' && !canUseFidelity()">
            {{ item.libelle }}<ng-container *ngIf="item.codification === 'FIDELITY' && clientFidelite"> ({{ clientFidelite.montant_equivalent ?? 0 }} disponible)</ng-container>
          </option>
        </select>
        <div class="text-danger" *ngIf="mode_reglement_idCtrl.invalid && mode_reglement_idCtrl.touched">
          Mode règlement est requis
        </div>
        <div class="text-info small mt-1" *ngIf="isFidelitySelected() && clientFidelite">
          Solde fidélité : {{ clientFidelite.montant_equivalent ?? 0 }}
        </div>
        <div class="text-warning small mt-1" *ngIf="isFidelitySelected() && clientFidelite && clientFidelite.montant_equivalent < (itemToSave.montant_avance ?? 0)">
          Points insuffisants
        </div>
      </div>

      <!-- Caisse -->
      <div class="col-md-2 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Caisse</label>
        <select class="form-select" [(ngModel)]="itemToSave.caisse_id" name="caisse_id" #caisse_idCtrl="ngModel"
          required>
          <option *ngFor="let item of itemsUserCaisse" [value]="item.caisse_id">{{ item.caisse_libelle }}</option>
        </select>
        <div class="text-danger" *ngIf="caisse_idCtrl.invalid && caisse_idCtrl.touched">
          Caisse est requis
        </div>
      </div>

      <!-- Montant reçu -->
      <div class="col-md-2 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Montant reçu</label>
        <input type="number" class="form-control" [(ngModel)]="itemToSave.montant_recu" name="montant_recu"
          #montant_recuCtrl="ngModel" (input)="onCalculateMonnaie()" required />
        <div class="text-danger" *ngIf="montant_recuCtrl.invalid && montant_recuCtrl.touched">
          Montant reçu est requis
        </div>
      </div>

      <!-- Monnaie rendue -->
      <div class="col-md-2 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Monnaie rendue</label>
        <input type="number" class="form-control" [(ngModel)]="itemToSave.monnaie_rendue" name="monnaie_rendue"
          #monnaie_rendueCtrl="ngModel" required />
        <div class="text-danger" *ngIf="monnaie_rendueCtrl.invalid && monnaie_rendueCtrl.touched">
          Monnaie rendue est requis
        </div>
      </div>

      <!-- Référence règlement -->
      <div class="col-md-2 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Référence règlement</label>
        <input type="text" class="form-control" [(ngModel)]="itemToSave.reference_reglement" name="reference_reglement"
          #reference_reglementCtrl="ngModel" required />
        <div class="text-danger" *ngIf="reference_reglementCtrl.invalid && reference_reglementCtrl.touched">
          Référence est requis
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="getItemsChambre()" [disabled]="!(itemToSave.duree_supplementaire>0)">Sauvegarder</button>
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">Fermer</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Sauvegarder</button>
  </div>
</form>